import Form from '@/utils/form'
const State = vars => new Form({ ...vars })

export default State
